import { useApolloClient, useMutation, useQuery } from '@apollo/client'
import { AuthContext } from '@deltek/specification-client/core/Configurations/AuthContext'
import { InsertCurrentUserInfoMutation } from '@deltek/specification-client/core/GraphQL/Mutations/currentUserInfo.mutations'
import { CurrentUserInfoQuery } from '@deltek/specification-client/core/GraphQL/Queries/currentUserInfo.queries'
import { CurrentUserInfoResponse } from '@deltek/specification-client/core/Models/currentUserInfo'
import React, { useContext, useEffect } from 'react'

const ApolloCacheKey = 'specpoint-cache'

const CurrentUserConfiguration: React.FC = ({ children }) => {
    const client = useApolloClient()
    const { currentUserInfo } = useContext(AuthContext)
    const { data: currentUserInfoResponse } = useQuery<CurrentUserInfoResponse>(
        CurrentUserInfoQuery
    )
    const [insertCurrentUserInfo] = useMutation<CurrentUserInfoResponse>(
        InsertCurrentUserInfoMutation
    )

    useEffect(() => {
        if (
            currentUserInfo &&
            (!currentUserInfoResponse ||
                currentUserInfoResponse.currentUserInfo.account.accountId !==
                    currentUserInfo.account.accountId)
        ) {
            insertCurrentUserInfo({
                variables: {
                    currentUserInfo,
                },
            })
        } else if (
            (currentUserInfoResponse?.currentUserInfo?.b2cUserId?.length ?? 0) >
                0 &&
            currentUserInfo.b2cUserId !==
                currentUserInfoResponse?.currentUserInfo?.b2cUserId
        ) {
            // if a new user signed in, clear cache.
            localStorage.removeItem(ApolloCacheKey)
            window.location.reload()
        }
    }, [
        currentUserInfo,
        currentUserInfoResponse,
        insertCurrentUserInfo,
        client,
    ])

    return <>{children}</>
}

export default CurrentUserConfiguration
